<template>
    <div class="addFirstPlaning">
        <div class="content">
            <div class="topTitle">
                <span :class="navIndex >= 0 ? 'active':''">目标规划</span>
                <span :class="navIndex >= 1 ? 'active':'' ">&gt;&gt;&gt;&gt;路径规划</span>
                <span :class="navIndex >= 2 ? 'active':'' ">&gt;&gt;&gt;&gt;选科规划</span>
            </div>
            <div v-show="navIndex==0">
                <div class="mine-planningContent-careerTuijian">
                    <p class="tuijianTitle">测评报告相关推荐</p>
                    <div class="tuijian">
                        <p>{{version==1?'目标职业领域':'目标职业类'}}：{{careerMajorObj.targetCareerField}}</p>
                        <p>目标职业：
                            <span v-for="(value,index) in careerMajorObj.targetCareer" :key="index"><template v-if="index!= '0'">、</template>{{value}}</span>
                        </p>
                        <p v-if="version==2||version==0">
                            目标专业类：
                           <span><template v-if="index!= '0'"></template>{{professional}}</span> 
                        </p>
                        <p>目标专业：
                            <span v-for="(value,index) in careerMajorObj.targetSubject" :key="index" ><template v-if="index!= '0'">、</template>{{value}}</span>
                        </p>
                        
                    </div>
                </div>
                <GoalPlanning
                    :goalPlanObj="goalPlanObj"
                    :furtherWayObj="furtherWayObj"
                    :chooseSubjectObj="chooseSubjectObj"
                ></GoalPlanning>
            </div>
            <div v-if="navIndex==1">
                <div class="achieve">
                    <p class='bigTitle'>个人成就</p>
                    <ul>
                        <template>
                            <li v-for="(value,index) in awarded" :key="index">
                                <p v-show="value.name">奖励名称：{{value.name}}</p>
                                <p v-show="value.year">获奖年份：{{value.year}}</p>
                                <p v-show="value.grade">获奖级别：{{value.grade}}</p>
                            </li>
                        </template>

                        <li>
                            <p>
                                意向路径：
                                <template v-if="otherWayList.length">
                                    <span v-for="(value,index) in otherWayList" :key="index">{{index!=0?'、':''}}{{value}}</span>
                                </template>
                                <template v-else>
                                    暂无意向路径
                                </template>
                            </p>
                        </li>
                    </ul>
                </div>
                <div class="targetSchool">
                    <p class='bigTitle'>目标大学</p>
                    <p class='targetSchoolBox'>
                        <template v-if="goalPlanObj.universityIdName.length">
                            <span v-for="(value,index) in goalPlanObj.universityIdName">{{value.name}}</span>
                        </template>
                        <template v-else>无</template>
                    </p>
                </div>
                <p class='bigTitle'>升学途径分析</p>
                <div v-if="reportData">
                    <FurtherWayReport :reportData="reportData"></FurtherWayReport>
                </div>
                <p v-else style="font-size: 20px;margin-bottom: 20px;">暂无升学途径报告！</p>
                <WayPlanning
                    :goalPlanObj="goalPlanObj"
                    :furtherWayObj="furtherWayObj"
                    :chooseSubjectObj="chooseSubjectObj"
                ></WayPlanning>
            </div>
            <div v-if="navIndex==2">
                <SubjectPlanning
                    :goalPlanObj="goalPlanObj"
                    :furtherWayObj="furtherWayObj"
                    :chooseSubjectObj="chooseSubjectObj"
                    :careerMajorObj="careerMajorObj"
                ></SubjectPlanning>
            </div>

        </div>
        <div class="btnBox" style="display: flex;justify-content: space-around;padding: 45px 0px;width: 300px;margin: 0px auto;">
            <!--<Button @handleClick="submitForm('ruleForm',true)" :type="'btnGray'" :name="预览" ></Button>-->
            <Button @handleClick="goSubmit" :type="'btnBlue'" :name="navList[navIndex].btnName" ></Button>
        </div>
        <InterviewPopup :interviewRecord="interviewRecord"   :isInputReadOnly="true"    v-on:closePop="()=>isShowPop=false" v-show="isShowPop"></InterviewPopup>
    </div>
</template>
<script>
import FurtherWayReport from './furtherWayReport.vue'
import GoalPlanning from '@/components/consultant/planningContent/GoalPlanning.vue'
import WayPlanning from '@/components/consultant/planningContent/WayPlanning.vue'
import SubjectPlanning from '@/components/consultant/planningContent/SubjectPlanning.vue'
import InterviewPopup from '@/components/consultant/InterviewPopup.vue'
import Button from '@/components/Button.vue'
export default {
    name: "addFirstPlaning",
    components: {
        FurtherWayReport,
        GoalPlanning,
        WayPlanning,
        SubjectPlanning,
        Button,
        InterviewPopup
    },
    data() {
        return {
            isShowPop: true,
            awarded: [],
            otherWayList: [],
            reportData: null,
            interviewRecord: {
                category: '2',//类别：1首次访谈 2规划内容 3 计划执行
                interviewTime: '',//访谈时间
                interviewNum: '',//第几次访谈
                interviewTheme: '初次规划',//访谈主题
            },//访谈记录


            navIndex: 0,
            navList: [
                {navIndex: 0,nowPage:'GoalPlanning',btnName: '前往路径规划'},
                {navIndex: 1,nowPage:'WayPlanning',btnName: '添加选科规划'},
                {navIndex: 2,nowPage:'SubjectPlanning',btnName: '确认规划'},
            ],
            studentId: sessionStorage.getItem('myStudentStudentId'),//学生id
            isFinishCareer: true,

            // targetCareerField:'',
            // targetCareer: [],
            // targetSubject:[],
            careerMajorObj: {
                careerDataIndex: '0',
                targetCareerField: '',
                targetCareer: [],
                targetSubject: [],
                targetRemark: '',
                
            },
            goalPlanObj: {
                universityScore: [],
                universityIdName:[],
                score: '',
                rank: '',
                remarkLog: '',//咨詢記錄
            },
            furtherWayObj: {
                furtherWay: '',//升学路径
                furtherWayNeed:'',//路径条件
                furtherWayNeedOther:'',//其他条件
                furtherWayRemark: '',//咨询总结
            },
            chooseSubjectObj: {
                chooseSubjectName: [],//選科方案
                chooseSubjectRequire: [],//目标院校对目标专业的选科要求
                chooseSubjectRemark: '',//选科调整记录
                hadCheckedList:[],
                
            },
            version:1,
            professional:'',

            // reportData: {
            //     "totalNum": 25,
            //     "recommendNum": 7,
            //     "unRecommendNum": 3,
            //     "conformNum": 10,
            //     "recommend": [{
            //         "id": 1,
            //         "title": "裸分统招",
            //         "introduction": "裸分统招是指不借助任何一种途径获得高考加分或录取优惠，仅通过参加高考进入理想大学的一种方式，目前大 部分学生均采用这种方式。但从往年数据来看，裸分进名校的几率在逐年减少。",
            //         "condition": ["裸分统招无特殊报考条件。"],
            //         "notice": ["① 自新高考改革以后，全国各地高中生将自主确定选考科目，各招生高校根据本校各专业选考科目，结合 统一高考和高中学业水平考试成绩，综合评价，择优录取。 ", "② 尽管裸分统招是目前大部分学生所采用的升学途径。但从往年的数据来看，裸分进名校的几率在逐年减 少。多种升学途径综合考虑已经成为越来越多考生的更优选择。"],
            //         "recommendReason": "您当前已具备报考条件。",
            //         "noRecommendReason": "",
            //         "incompatibleReason": "您不具备以下报考条件：",
            //         "link": "",
            //         "conditionOption": []
            //     }, {
            //         "id": 3,
            //         "title": "综合评价录取",
            //         "introduction": "综合评价录取依据统一高考成绩、学业水平考试成绩、面试成绩、普通高中综合素质评价进行录取，对高考成绩 达到相应省控线的入选考生，综合评价，择优录取。",
            //         "condition": ["①预计高考分数不低于本省（自治区、直辖市）本科二批、本科B批、本科批次、第二段控制线。"],
            //         "notice": ["① 在浙江省称为“三位一体”。目前北京大学的博雅计划，以及清华大学的领军计划均通过该方式录取，另 外有其他高校也在试点。 ", "② 相比自主招生对国奖、省奖等多种含金量大奖的明确要求，综评只要你高中学习成绩优秀就能报名，而 且初审通过率远远高于自主招生。 ", "③ 大多数进行综合评价录取的高校都在阳光高考综合评价报名页面网址（http:\/\/bm.chsi.com.cn\/）里报 名。少数学校比如：中国科学院大学、南方科技大学、上海科技大学、中南大学(分数线,专业设置)等是在 本校本科招生网站上报名。 ", "④ 并不是所有的高校都具有综合评价招生资格，某些具有综合评价招生资格的高校并不是面对全国来招生 的。目前面向本省考生实施综合评价录取试点的省份为：浙江、上海、山东、广东、江苏、湖南、云南、 辽宁。 ", "⑤ 考生和家长一定要仔细阅读学校的招生章程，一个学校的招生人数、报考条件以及考试科目、优惠政策 都在章程中，是非常重要的参考。 ", "⑥ 各省份对于综合评价录取的成绩要求有所不同，考生可在本省的招生考试院官网上进行查询。 ", "⑦ 综合评价录取需要相关报考材料，建议从高一就开始准备。"],
            //         "recommendReason": "您当前已具备以下报考条件：",
            //         "noRecommendReason": "",
            //         "incompatibleReason": "您不具备以下报考条件：",
            //         "link": "\/wayToStudy\/comprehensiveevaluation",
            //         "conditionOption": ["①"]
            //     }, {
            //         "id": 4,
            //         "title": "保送生",
            //         "introduction": "保送生无需参加高考(有的省规定保送生可自愿参加高考，但不再参加统一录取)。符合保送条件的学生经中学推 荐，并通过大学测试合格后即可进入大学就读。",
            //         "condition": ["①为中学生学科奥林匹克竞赛国家集训队成员。", "②为部分外国语中学推荐优秀学生。", "③为公安英烈子女。", "④为退役运动员。"],
            //         "notice": ["① 公安英烈子女按有关规定只能保送至公安类院校。 ", "② 已确认保送录取的学生不再参加普通高校招生全国统一录取。 ", "③ 2017年秋季及以后进入高中阶段一年级的学生，将取消省级优秀学生保送资格条件，2020年起所有高 校停止省级优秀学生保送生招生。 ", "④ 2018年起符合条件的运动员可保送至高校体育学类本科专业，如果运动员申请就读其他专业，应参加国 家体育总局统一组织的运动训练、武术与民族传统体育专业单独招生文化课考试，由高校自主划定文化课 录取分数线。 ", "⑤ 退役运动若满足以下三种条件之一可获得免试资格：曾获指定项目比赛最高级别组（查看详情）全国前 三名、亚洲前六名、世界前八名，武术套路传统项目运动员需同时获得运动健将等级称号;获得足球、篮 球、排球、田径和武术项目运动健将称号;获得国际级运动健将称号。 ", "⑥ 高校要安排外国语言文学类专业招收外国语中学推荐保送生，并向国家“一带一路”战略发展所需非通用 语种专业倾斜。 ", "⑦ 各省具体保送条件略有调整，请登录考生所在省考试院官网查看保送生相关最新消息。"],
            //         "recommendReason": "您当前已具备以下报考条件：",
            //         "noRecommendReason": "",
            //         "incompatibleReason": "您不具备以下报考条件：",
            //         "link": "\/wayToStudy\/recommendedstudent",
            //         "conditionOption": ["①", "②", "③", "④"]
            //     }, {
            //         "id": 8,
            //         "title": "国家专项计划",
            //         "introduction": "国家专项计划定向招收集中连片特殊困难县、国家级扶贫开发重点县以及新疆南疆四地州学生，如果考生所在地 域在国家专项计划招生范围内，可考虑报考国家专项计划。",
            //         "condition": ["① 本人具有实施区域当地连续3年以上户籍，其父亲或母亲或法定监护人具有当地户籍。", "② 本人具有户籍所在县(市、区)高中连续3年学籍并实际就读。", "③ 预计高考分数不低于本省（自治区、直辖市）本科二批、本科B批、本科批次、第二段控制线。"],
            //         "notice": ["① 对于尚未合并本科批次的省份，国家专项计划在本科一批前开始投档录取，录取分数原则上不低于招生 学校普通类招生所在批次录取控制分数线。 ", "② 对于合并本科录取批次的有关省份，国家专项计划在本科批次前开始投档录取，录取分数不低于本科批 次录取控制分数线。 ", "③ 部分省份在特殊情况下，在高考录取过程中二本分数也可以通过国家专项计划中未完成招生计划的一本 院校在二本控制线上征集志愿，进而录取到一本院校。 ", "④ 国家专项无需参加高校考核，但每个省份对国家专项的批次均有不同，请各位考生在志愿填报时注意批 次，符合条件的考生避免错填漏填。 ", "⑤ 各省份对于国家专项计划的成绩要求有所不同，考生可在本省的招生考试院官网上进行查询。"],
            //         "recommendReason": "您当前已具备以下报考条件：",
            //         "noRecommendReason": "",
            //         "incompatibleReason": "您不具备以下报考条件：",
            //         "link": "\/wayToStudy\/threespecialplan",
            //         "conditionOption": ["①", "②", "③"]
            //     }, {
            //         "id": 10,
            //         "title": "高水平运动队",
            //         "introduction": "高水平运动队主要招收竞技水平程度比较高的考生教育部对高水平运动队招生项目也有明确的规定。",
            //         "condition": ["① 如果学生是普通高中学生，应有能力获得国家二级运动员(含)以上证书且高中阶段在省级(含)以上比赛中获得集体项目前六名的主力队员或个人项目前三名。", "② 如果学生是中专或具有高级中等教育毕业同等学力的学生，应有能力获得国家一级运动员(含)以上证书者，或近三年内在全国(或国际)集体项目比赛中获得前八名的主力队员。", "③ 预计高考分数不低于本省（自治区、直辖市）本科二批、本科B批、本科批次、第二段控制线。"],
            //         "notice": ["① 对于尚未合并本科批次的省份考生，若少数体育测试成绩特别突出，高校可适度降低文化成绩录取要 求，但不得低于生源省份本科第二批次录取控制分数线的65%，此类考生人数不超过当年高水平运动队招 生计划的30%。 ", "② 考生入校后要接受所在院系和运动队双重管理，既要按本专业培养方案完成专业学习任务，也要认真 履行参加训练和比赛的义务。 ", "③ 凡符合试点高校高水平运动队报名条件且获得一级运动员、运动健将、国际健将称号之一，拟申请试点 高校单独招生考试资格的考生，应及时登录教育部阳光高考平台或中国运动员文化教育网的“高校高水平运 动队文化考试报名系统”自主报名。 ", "④ 高水平运动队需要提供相关报考材料并通过相应考试。"],
            //         "recommendReason": "您当前已具备以下报考条件：",
            //         "noRecommendReason": "",
            //         "incompatibleReason": "您不具备以下报考条件：",
            //         "link": "\/wayToStudy\/sportsteam",
            //         "conditionOption": ["③", "②"]
            //     }, {
            //         "id": 15,
            //         "title": "公费师范生",
            //         "introduction": "公费师范生是国家在2007年推出的一项政策，旨在培养大批优秀的中小学教师，鼓励更多的优秀青年终身做教育 工作者。",
            //         "condition": ["① 参加普通高校招生全国统一考试，达到部属师大在本地区的录取分数线；", "②有意愿毕业后回到学籍所在地的省份从事中小学教育工作。"],
            //         "notice": ["① 公费师范生入学前需要与学校和生源所在地省级教育行政部门签订协议——《师范生公费教育协议》， 毕业后一般回生源所在地省份从事中小学教育6年以上。 ", "② 招生院校为教育部直属6所师范院校、部分省份省属本专科师范院校，一般情况下在提前批次填报。其 中，省属师范院校往往定向就业，具体政策可详见考生所在地省份教育考试院的具体实施意见。 ", "③ 公费师范生在校学习期间，享受“二免一补”，即免除学费，免缴住宿费，并补助生活费。 ", "④ 公费师范生本科毕业后，到中小学任教满一学期，可免试攻读非全日制教育硕士专业学位。在毕业前及 在协议规定服务期内，一般不得报考脱产研究生。 ⑤ 不履行协议须交违约金:公费师范毕业生未按协议从事中小学教育工作的，要按规定退还已享受的公费 教育费用并缴纳违约金。省级教育行政部门负责履约管理，并建立公费师范生的诚信档案。确有特殊原因 不能履行协议的，需报经省级教育行政部门批准。"],
            //         "recommendReason": "您当前已具备以下报考条件：",
            //         "noRecommendReason": "您当前未具备以下报考条件：",
            //         "incompatibleReason": "",
            //         "link": "\/wayToStudy\/publicexpense",
            //         "conditionOption": ["②"]
            //     }, {
            //         "id": 17,
            //         "title": "中外合作办学",
            //         "introduction": "中外合作办学通常是指外国教育机构同中国教育机构在中国境内合作举办的以中国公民为主要招生对象的教育机 构，目前所称的中外合作办学一般是指国家鼓励的在高等教育、职业教育领域开展的中外合作办学。中外合作办 学有合作设立机构和合作举办项目两种形式。",
            //         "condition": ["① 家庭具备一定的经济基础。"],
            //         "notice": ["① 部分中外合作办学类专业对外语成绩有明确的要求。 ", "② 中外合作办学的模式往往有“3+1”、“2+2”、“4+0”三种模式，前者为国内就读时间，后者为国外就读时 间，可以选择不出国。 ", "③ 国内共有宁波诺丁汉大学、西交利物浦大学、昆山杜克大学、广东以色列理工学院 、上海纽约大学、 温州肯恩大学、香港中文大学(深圳)、北京师范大学-香港浸会大学联合国际学院、深圳北理莫斯科大学等 9所具有独立法人资格的中外合作机构（亦称“中外合作大学”）。 ", "④ 国内985\/211学校的中外合作办学项目值得推荐，是低分高就的有效方式。 ", "⑤ 详细信息可查询教育部中外合作办学监管信息平台http:\/\/www.crs.jsj.edu.cn\/index。"],
            //         "recommendReason": "您当前已具备以下报考条件：",
            //         "noRecommendReason": "您当前未具备以下报考条件：",
            //         "incompatibleReason": "",
            //         "link": "\/wayToStudy\/sinoforeigncooperation",
            //         "conditionOption": ["①"]
            //     }],
            //     "unRecommend": [{
            //         "id": 5,
            //         "title": "港澳招生",
            //         "introduction": "港澳招生是指是指香港、澳门的院校在内地进行招生。如果你的英语水平足够高，而且有想去港澳学习的意向，不妨考虑港澳招生途径。目前，在内地招生的21所港澳高校有两种招生方式：一种是香港中文大学和香港城市大学2所高校采用的统招方式，另一种是香港大学等13所香港高校和澳门大学等6所澳门高校采用的独立招生方式。",
            //         "condition": ["① 预计高考分数不低于本省（自治区、直辖市）本科二批、本科B批、本科批次、第二段控制线。", "② 有意愿将来在香港或澳门读大学。"],
            //         "notice": ["① 自2011年起，有关港澳高校可在全国31个省、直辖市、自治区招收自费生。 ", "② 内地考生必须符合中国政府有关赴港澳就读的规定；必须参加当年普通高等学校全国统一招生考试。 ", "③ 香港高校每年费用16-18万港币，澳门高校每年费用约7.2万人民币。具体各校略有不同，详细情况请参 照所申请院校官网。 ", "④ 各高校为成绩优异的考生提供丰厚的奖学金。值得注意的是能拿到全额奖学金的是很小一部分考生，绝 大多数考生需要自费。自费生入读后虽然可申请各类奖助学金，但竞争非常激烈。 ", "⑤ 一般情况下，申请学生签证的时间为4-6周。内地同学获录取后，应立即着手办理申请香港、澳门特区 入境签证手续。学校会在发出录取通知书的同时，把香港、澳门特区入境签证申请表格一同寄给考生。 ", "⑥ 港澳招生需要通过相关考试，建议从高一就开始准备，同时注重英语能力的提升。"],
            //         "recommendReason": "您当前已具备以下报考条件：",
            //         "noRecommendReason": "您当前未具备以下报考条件：",
            //         "incompatibleReason": "您不具备以下报考条件：",
            //         "link": "\/wayToStudy\/gangaorecruitstudents",
            //         "conditionOption": ["②"]
            //     }, {
            //         "id": 20,
            //         "title": "海外留学",
            //         "introduction": "海外留学是指去本国以外的其他国家接受各类学历教育。",
            //         "condition": ["① 家庭具备一定的经济基础。", "② 有意愿在海外留学或就业。"],
            //         "notice": ["① 部分院校对高中在读成绩有要求，考生需要提供相关GPA，具体信息可登陆相关院校官网查询。 ", "② 部分院校对高考成绩有要求，高考成绩需要达到考生所在省份相应的批次线，具体信息可登陆相关院校 官网查询。 ", "③ 部分院校对语言成绩有明确要求，不同地区对语言考试的种类和通过等级要求不同，具体信息可登陆相 关院校官网查询。 ", "④ 国外院校往往是申请制，需要提前进行相关竞赛、活动的准备并进行语言学习，最后提交相关申请材 料。"],
            //         "recommendReason": "您当前已具备以下报考条件：",
            //         "noRecommendReason": "您当前未具备以下报考条件：",
            //         "incompatibleReason": "",
            //         "link": "\/wayToStudy\/studyingabroad",
            //         "conditionOption": ["②"]
            //     }, {
            //         "id": 21,
            //         "title": "高职单招",
            //         "introduction": "高职单招是高职院校“单考单招”和“自主招生”的统称，指除了高考之外，考生进入高职院校的另一选拔途径，通 过该途径被录取的考生与参加高考被录取的考生享受同等待遇。",
            //         "condition": ["①高职单招无特殊报考要求。"],
            //         "notice": ["① 目前仅长沙民政职业技术学院、重庆城市管理职业学院、北京社会管理职业学院这3所学校招收其他省 份的学生。其他院校仅面向本省招生。 ", "② 国家授权高职院校独立组织考试录取的一种方式，必须于高考前完成。 ", "③ 凡被高职单招录取的考生，一律不再参加普通高考。 ", "④ 单招学校毕业后所拿的文凭和通过高考拿的文凭是完全相同，资助、奖评及毕业后待遇等与全国普通高 校招生统一录取的考生完全相同。 ", "⑤ 在校读书期间不能转学、转专业。"],
            //         "recommendReason": "您当前已具备以下报考条件：",
            //         "noRecommendReason": "依照您目前预计的高考成绩，您有条件进入更好的大学进行深造。",
            //         "incompatibleReason": "",
            //         "link": "\/wayToStudy\/gaozhidanzhao",
            //         "conditionOption": []
            //     }],
            //     "incompatible": [{
            //         "id": 6,
            //         "title": "高校专项计划",
            //         "introduction": "高校专项计划主要招收边远、贫困、民族等地区县(含县级市)以下农村学生，招生学校为教育部直属高校和其他 自主招生试点高校。2017年，全国共95所高校具有高校专项计划招生资格。",
            //         "condition": ["① 同时具备以下3个条件：本人及父亲或母亲或法定监护人户籍地在实施区域的农村;本人具有当地连续3年以上户籍。② 本人具有户籍所在县高中连续3年学籍并实际就读。", "③ 预计高考分数不低于本省（自治区、直辖市）本科一批、本科A批、自主招生、第一段控制线。"],
            //         "notice": ["① 高校专项计划招生办法由有关高校确定并在招生简章中明确，录取分数原则上不低于有关高校普通类招 生所在批次录取控制分数线。 ", "② 高校专项计划需要单独报名并提供相关报考材料。报名需要登录特殊类型招生报名平台 http:\/\/gaokao.chsi.com.cn\/gxzxbm ", "③ 考生需要高考当年4月份左右完成报名申请，5月底前省市及高校会公布审核通过名单。审核通过的考生 需要在高考后参加高校相应的笔试考核，获得资格的考生需要在高考出分后在单独填报志愿。"],
            //         "recommendReason": "您当前已具备以下报考条件：",
            //         "noRecommendReason": "",
            //         "incompatibleReason": "您不具备以下报考条件：",
            //         "link": "\/wayToStudy\/threespecialplan",
            //         "conditionOption": ["①", "③"]
            //     }, {
            //         "id": 7,
            //         "title": "地方专项计划",
            //         "introduction": "地方专项计划定向招收各省(区、市)实施区域的农村学生。",
            //         "condition": ["① 户籍为农村。", "② 预计高考分数不低于本省（自治区、直辖市）本科二批、本科B批、本科批次、第二段控制线。"],
            //         "notice": ["① 只有所在省市的部分一本院校和二本院校中的一本专业。", "② 学校为各省(区、市)所属重点高校，具体实施区域、报考条件由各省(区、市)根据本地实际情况确定， 考生可登陆所在地省份教育考试院官网查询具体实施区域。 ", "③ 地方专项无需参加高校考核，但每个省份对地方专项的批次均有不同，请各位考生在志愿填报时注意批 次，符合条件的考生避免错填漏填。 ", "④ 各省份对于地方专项计划的成绩要求有所不同，考生可在本省的招生考试院官网上进行查询。"],
            //         "recommendReason": "您当前已具备以下报考条件：",
            //         "noRecommendReason": "",
            //         "incompatibleReason": "您不具备以下报考条件：",
            //         "link": "\/wayToStudy\/threespecialplan",
            //         "conditionOption": ["①"]
            //     }, {
            //         "id": 9,
            //         "title": "高水平艺术团",
            //         "introduction": "高水平艺术团主要招收具备声乐、器乐、舞蹈、戏剧等方面特长的考生，考生录取后进入普通专业学习，并利用 课余时间参加文艺排练和演出。目前有53所试点高校招收高水平艺术团考生。",
            //         "condition": ["① 具备以下艺术类特长：如声乐（美术、书法、播音与主持除外）、器乐、舞蹈、戏剧等。", "② 预计高考分数不低于本省（自治区、直辖市）本科一批、本科A批、自主招生、第一段控制线。"],
            //         "notice": ["① 对于上海、浙江考生来说，针对少数专业成绩突出的学生，高校可适度降低文化课成绩录取要求，但不 得低于相关高校最低录取控制参考线。 ", "② 各高校的招生项目是不同的，同一高校不同项目的招生人数也相差很大。因此，考生一定要先查阅高校 的章程，看看当年有哪些高校招收自己的特长项目。 ③ 艺术团招生主要招收艺术团首席表演者或对幼功要求高的相关专业项目的艺术团成员，不招收与艺术团 无关的艺术特长生。 ", "④ 从2017年起，艺术团学生要接受所在院系和艺术团的双重管理，既要完成本专业的学习任务，还要认真 履行排练演出义务。 ", "⑤ 2018年后，已开设有艺术类专业的试点高校不再单独招收相应专业项目的艺术特长生（如高校招收小提 琴方向的艺术类专业学生，就不得再招收小提琴项目的艺术特长生）。 ", "⑥ 高水平艺术团需要提供相关报考材料并通过相应考试。"],
            //         "recommendReason": "您当前已具备以下报考条件：",
            //         "noRecommendReason": "",
            //         "incompatibleReason": "您不具备以下报考条件：",
            //         "link": "\/wayToStudy\/artensemble",
            //         "conditionOption": ["①", "②"]
            //     }, {
            //         "id": 11,
            //         "title": "艺术类专业",
            //         "introduction": "艺术类专业是指普通高等艺术类院校招生的专业或普通高等学校的艺术类专业，例如：音乐、美术、表演、舞 蹈、编导、播音主持等专业。艺术类专业招生是为高等艺术教育选拔具有较高艺术素质和艺术领悟力的专业人 才。",
            //         "condition": ["① 具备一定的艺术类特长，如音乐、美术、表演、舞蹈、编导、播音主持等。", "② 有意愿就读艺术类专业（如：设计学类、美术学类、戏剧与影视学类、音乐与舞蹈学类、艺术学理论类等下设专业）"],
            //         "notice": ["① 招生院校为高等艺术类院校以及普通类院校。 ", "② 凡艺术类专业录取的学生，入学后不得转入非艺术类专业。 ", "③ 色盲的考生不能报考美术学、绘画、艺术设计、摄影、动画等专业。此外，听力不合格的考生不宜就读 音乐学、录音艺术等专业;嗅觉迟钝、口吃、步态异常、驼背，面部疤痕、血管瘤、黑色素痣、白癜风的考 生，不宜就读音乐表演、表演等专业。 ", "④ 招生院校可能会对某些专业提出更多的要求，例如身高等。考生在报考时，要认真阅读当年的招生简章 或者咨询高校。 ", "⑤ 考生所报考专业在省统考范围内的，必须参加省统考。全国所有省级招办都会组织美术学类和设计学类 专业省统考，有的省(区、市)还会组织音乐类、舞蹈类等专业统考。详情请关注本省招办当年的艺术类专 业招生工作通知。省统考未涉及的专业，考生参加校考即可。 ", "⑥ 报考艺术类专业的考生，可以兼报除提前录取批次外的其他批次的非艺术类专业，但要注意艺术类各批 次和普通类各批次录取时间的先后顺序，录取时间重叠的批次不能兼报。(如生源所在省级招办另有规定， 则以省级招办当年规定为准。) ", "⑦ 报考艺术类专业需要通过相应考试，建议从高一就开始准备。"],
            //         "recommendReason": "您当前已具备以下报考条件：",
            //         "noRecommendReason": "您当前未具备以下报考条件：",
            //         "incompatibleReason": "您不具备以下报考条件：",
            //         "link": "\/wayToStudy\/artenrollment",
            //         "conditionOption": []
            //     }, {
            //         "id": 12,
            //         "title": "体育单招",
            //         "introduction": "体育单招是部分体育专业单独招生的简称，是指经教育部、国家体育总局批准的部分院校可以对运动训练、武术 与民族传统体育(注：原名民族传统体育)专业实行单独招生。",
            //         "condition": ["① 具备国家二级运动员（含）以上证书或称号。", "② 视力：任何一眼裸眼视力不得低于4.8（E字表）无色盲、色弱斜视等眼疾。", "③ 有意愿就读运动训练、武术与民族传统体育专业。"],
            //         "notice": ["① 在体育单招项目中，运动训练专业设11个冬季项目，49个其他项目；武术与民族体育专业设3个项目。 ", "② 考生依据各院校招生简章要求，统一在“中国运动文化教育网”体育单招管理系统中报名。 ", "③ 实行文化考试与体育专项考试相结合的办法，文化考试往往在4月份进行，体育专项考试时间分项目不 同考试时间不同。 ", "④ 招生院校自行确定本校文化成绩和专业成绩的录取控制线，对具备一级运动员等级的考生，可降低线下 30分录取；对具备运动健将技术等级的考生，可降低50分录取。 ", "⑤ 考生若已被运动训练、武术与民族传统体育专业录取，则不再参加普通高考及高校高水平运动队的录 取。", "⑥ 2018年起，运动训练专业多了象棋一项。 ", "⑦ 体育单招需要通过相应考试，建议从高一就开始准备。"],
            //         "recommendReason": "您当前已具备以下报考条件：",
            //         "noRecommendReason": "您当前未具备以下报考条件：",
            //         "incompatibleReason": "您不具备以下报考条件：",
            //         "link": "\/wayToStudy\/tiyudanzhao",
            //         "conditionOption": ["①", "②"]
            //     }, {
            //         "id": 13,
            //         "title": "体育类专业",
            //         "introduction": "体育类专业招生主要是指普通高校体育类专业(即体育教育、社会体育指导与管理、休闲体育等专业)的招生。凡 符合普通高校招生报考条件，具有一定体育专长的考生，都可报名参加体育类专业招生。",
            //         "condition": ["① 年龄：高考时年龄不超过22周岁。", "② 具备以下体育类特长：如田径、篮球、排球、足球、网球、羽毛球、乒乓球、体操、武术、游泳等。", "③ 有意愿就读体育类专业（如：运动训练、武术与民族传统体育、体育教育、社会体育指导与管理、休闲体育等专业）。"],
            //         "notice": ["① 招生院校为普通高校体育类院校以及普通类高校。普通类高校一般分为体育单招和高水平运动队两种招 生形式。 ", "② 考生需要参加普通高考文化课考试，同时还要参加所在省(市、区)组织的体育类专业考试并取得合格成 绩。", "③ 部分省市对于身高、体重、视力状况等身体条件有额外要求，考生可在本省的招生考试院官网上进行查 询。", "④ 体育类专业考试一般包括身体素质考试项目(100米跑、原地推铅球、800米跑等)和专项技术考试项目 (田径、篮球、排球、足球、网球、羽毛球、乒乓球、体操、武术、游泳等)。部分省市还会组织面试。 ", "⑤ 报考运动人体科学、体育经济与管理、新闻学(体育新闻方向)等专业的考生一般不必参加体育专业考试 和面试，但须具备一定的体育运动基础。详见各省(市、区)当年体育类招生规定、办法等。 ", "⑥ 体育类专业包含文学、理学、管理学、教育学、艺术学5种学位授予类型，其中教育学、艺术学需要体 育考试，文学、理学、管理学则不需要。 ", "⑦ 报考体育类专业需要通过相应考试，一般建议从高一就开始进行准备。"],
            //         "recommendReason": "您当前已具备以下报考条件：",
            //         "noRecommendReason": "您当前未具备以下报考条件：",
            //         "incompatibleReason": "您不具备以下报考条件：",
            //         "link": "\/wayToStudy\/sportsmajor",
            //         "conditionOption": ["①", "②"]
            //     }, {
            //         "id": 14,
            //         "title": "航海类专业",
            //         "introduction": "航海类专业主要设置于海事类院校。航海类专业主要包括航海技术、轮机工程和船舶电子电气工程三个专业。",
            //         "condition": ["① 身高：航海技术专业要求身高1.65米及以上；轮机工程（海上方向）专业、船舶电子电气工程专业要求身高1.60米及以上。", "② 视力：航海技术专业要求双眼裸视力均能达0.5（相当于E字表4.7）及以上，且矫正视力均能达0.8（相当于E字表4.9）及以上。；轮机工程（海上方向）专业、船舶电子电气工程专业要求双眼裸视力均能达0.4（相当于E字表4.6）及以上，且矫正视力均能达0.6（相当于E字表4.8）及以上。", "③ 无色盲（弱）、无复视等眼疾。", "④ 有意愿就读以下专业：航海技术、轮机工程和船舶电子电气工程。", "⑤ 性别：一般建议为男生，可以忍受艰苦的条件，不适宜女生报考。"],
            //         "notice": ["① 航海类专业对于近视力还有额外要求（近视力是距离近视力表30厘米的条件下检测的实力）：双眼裸视 力均能达0.8（相当于E字表4.9）及以上；或者双眼裸视力均能达0.4（相当于E字表4.6）及以上，且双眼 矫正视力均能达1.0（相当于E字表5.0）及以上。 ", "② 其他要求参照《海船船员健康检查要求》。 ", "③ 航海类专业与普通本科专业在报考方面有一些特殊要求，主要体现在：对身体条件要求极高，不适宜女 生报考，只招少量女生。航海类专业并不适合所有学生报考，还请有意向报考的考生根据专业的工作性 质，分析自身情况，合理选择。 ", "④ 就业情况：长期处于海上工作，条件艰苦。 ", "⑤ 航海类专业一般需要在本专科提前批次填报。"],
            //         "recommendReason": "您当前已具备以下报考条件：",
            //         "noRecommendReason": "您当前未具备以下报考条件：",
            //         "incompatibleReason": "您不具备以下报考条件：",
            //         "link": "\/wayToStudy\/nauticalcategoryschool",
            //         "conditionOption": ["②"]
            //     }, {
            //         "id": 16,
            //         "title": "免费医学生",
            //         "introduction": "免费医学生是为农村基层医疗卫生机构定向招收培养的一种医学特殊招生模式。在培养方式上，免费医学生分5 年制本科和3年制专科两种，以5年制本科为主，培养专业主要是临床医学、中医学(含民族医学)专业，培养工作 主要由举办医学教育的地方高等学校承担。3年制专科主要面向乡镇卫生院以下的医疗卫生机构和欠发达地区乡 镇卫生院医疗卫生岗位。",
            //         "condition": ["① 同时具备以下2个条件：本人及父亲或母亲或法定监护人户籍地在实施区域的农村；本人具有当地连续3年以上户籍。", "② 有意愿就读以下专业（临床医学、中医学、蒙医学、藏医学、傣医学等专业）且接受在毕业后到有关基层医疗卫生机构服务6年。"],
            //         "notice": ["① 免费医学生在获取入学通知书前，须与培养学校和当地县级卫生行政部门签署定向就业协议，承诺毕业 后到有关基层医疗卫生机构服务6年。免费医学生在学期间户籍仍保留在原户籍所在地。 ", "② 免费医学生在校学习期间，享受“二免一补”，即免除学费，免缴住宿费，并补助生活费。 ", "③ 在培养方式上，免费医学生分5年制本科和3年制专科两种，以5年制本科为主，培养专业主要是临床医 学、中医学(含民族医学)专业，培养工作主要由举办医学教育的地方高等学校承担。3年制专科主要面向乡 镇卫生院以下的医疗卫生机构和欠发达地区乡镇卫生院医疗卫生岗位。 ", "④ 按照要求，国家免费医学生未按入学前签署的协议规定履约的，退还已减免的教育培训费用、生活补助 和以上费用50%的违约金；履约情况纳入医师诚信管理，公布违约记录，并记入人事档案。国家免费医学 生毕业后拒绝履约的，5年内不得应聘全省行政范围内的各级各类事业单位。"],
            //         "recommendReason": "您当前已具备以下报考条件：",
            //         "noRecommendReason": "您当前未具备以下报考条件：",
            //         "incompatibleReason": "您不具备以下报考条件：",
            //         "link": "\/wayToStudy\/freemedicalstudents",
            //         "conditionOption": ["①"]
            //     }, {
            //         "id": 18,
            //         "title": "公安院校",
            //         "introduction": "为了适应公安系统培养专业人才的需要，实行公安院校招生。分为公安现役院校以及普通公安院校两种。",
            //         "condition": ["① 年龄：不超过 22 周岁（外语专业不超过 20 周岁）。", "② 身高：男性身高不低于 1.70 米；女性身高不低于 1.60 米。", "③ 体重：男性体重不低于 50 公斤；女性：体重不低于 45 公斤。", "④ 视力：左右眼单眼裸视力，理科类专业应在 4.9 （ 0.8 ）以上，文科类专业应在 4.8 （ 0.6 ）以上。无色盲、色弱等眼疾。", "⑤ 无口吃（结巴）。"],
            //         "notice": ["① 除全国高考外，还需政治审查、体检、面试、体能测试等全部合格。 ", "② 需要在提前批次填报，本专业批次均设志愿。 ", "③ 公安普通院校毕业后可自主择业，现役院校需要定向公安系统，毕业后统一分配到公安边防、消防、警 卫部队、海警部队工作。 ", "④ 公安现役院校包括中国人民武装警察部队学院和公安海警学院，要求年龄不低于17周岁，不超过20周 岁（截止当年8月31日）。"],
            //         "recommendReason": "您当前已具备以下报考条件：",
            //         "noRecommendReason": "",
            //         "incompatibleReason": "您不具备以下报考条件：",
            //         "link": "\/wayToStudy\/policeschool",
            //         "conditionOption": ["①", "④", "⑤"]
            //     }, {
            //         "id": 19,
            //         "title": "民族预科班",
            //         "introduction": "少数民族预科班主要面向少数民族地区招生,分为民考民（用少数民族文字参加高考）、民考汉（用汉语参加考 试）两种。",
            //         "condition": ["① 为少数民族考生。"],
            //         "notice": ["① 高考录取要在招生院校非定向投档线下80分以内择优录取，在各省录取批次不同。", "② 预科往往为一年，结束后直接升入高校学习，无需重新参加统考。", "③ 一般分为两种情况：一种是预科阶段和正常的学习阶段都在报考高校学习，另一种是预科阶段在另一所学校学习，考试合格后转入报考高校学习。", "④ 毕业后一般不需要回生源所在地工作，个别学校要去生源地工作的，会在招生目录注明。"],
            //         "recommendReason": "您当前已具备以下报考条件：",
            //         "noRecommendReason": "",
            //         "incompatibleReason": "您不具备以下报考条件：",
            //         "link": "\/wayToStudy\/nationprepclass",
            //         "conditionOption": ["①"]
            //     }, {
            //         "id": 22,
            //         "title": "空军招飞",
            //         "introduction": "空军飞行人员是国家的特殊人才和宝贵资源，其招收培养属国家行为。招收飞行学员（简称招飞）工作，在国家 教育部、公安部、财政部和军委政治工作部领导下，由空军会同有关省（自治区、直辖市）的教育、公安部门组 织实施，纳入全国普通高校招生体系，是军队院校招生工作的重要组成部分。",
            //         "condition": ["① 年龄：高考时年龄17周岁-20周岁。", "② 性别：男性。", "③ 身高：164-185cm。", "④ 体重：不低于标准体重的80%、不高于标准体重的130%，标准体重（kg）=身高（cm）-110。", "⑤ 视力：裸眼视力C字表0.8以上（相当于E字表4.9），未做过视力矫治手术，无色盲、色弱、斜视等眼疾。", "⑥ 无口吃（结巴）。", "⑦ 预计高考分数不低于本省（自治区、直辖市）本科一批、本科A批、自主招生、第一段控制线。"],
            //         "notice": ["① 空军招飞采取两种培养模式：军事高等教育模式、“3+1”军地联合培养模式。“3+1”军地联合培养模式是 指从高中生飞行学员中择优遴选进入空军航空大学或清华大学、北京大学、北京航空航天大学“双学籍”飞 行员班学习。 ", "② 高中生飞行学员入空军航空大学后，实行3个月考察期，合格者取得学籍、军籍。 ", "③ 符合报考条件的学生在所在学校报名，报名截止时间为初选检测时间（10月-11月）。学生报名要自愿，并且应该得到家长的同意与支持。 ", "④ 空军招飞报名考生多、选拔内容多，考生除身体、检测并参加高考外，还需要接受政治考核。 ", "⑤ 空军招飞不收取任何报名和检测费用，复选、定选期间免费安排考生食宿，并按规定报销路费。 ", "⑥ 空军招飞往往在提前批次录取。"],
            //         "recommendReason": "您当前已具备以下报考条件：",
            //         "noRecommendReason": "",
            //         "incompatibleReason": "您不具备以下报考条件：",
            //         "link": "\/wayToStudy\/airforce",
            //         "conditionOption": ["①", "④", "⑤", "⑥", "⑦"]
            //     }, {
            //         "id": 23,
            //         "title": "海军招飞",
            //         "introduction": "海军招收飞行学员工作在教育部、公安部、军委政治工作部统一部署和领导下开展，由海军招收飞行学员工作办公室（简称海军招飞办）和有关省、自治区、直辖市的教育、招生、公安部门共同组织实施，纳入国家高等教育统一招生计划，是军队院校招生工作的重要组成部分。",
            //         "condition": ["① 年龄：高考时年龄为16-19周岁。", "② 性别：男性。", "③ 身高：身高165—185厘米(赤脚测量)。", "④ 体重：体重在52千克以上，未满18周岁体重在50千克以上(偏瘦或过胖者不宜上站)。", "⑤ 视力：用C字视力表检查，双眼裸眼远视力不低于0.8(相当于E字表4.9)，无色盲、色弱等眼疾，未做过视力矫正术(如准分子手术、戴OK镜等)。", "⑥ 无口吃（结巴）者。", "⑦ 具有海军开招地区学校学籍和开招省市户籍。", "⑧ 预计高考分数不低于本省（自治区、直辖市）本科一批、本科A批、自主招生、第一段控制线。", "⑨ 高考时外语考英语。"],
            //         "notice": ["① 海军飞行学员在海军航空大学接受全日制本科学历教育，入校3个月考察期满后取得学籍和军籍，主要进行本科基础教育（“双学籍”飞行学员在北京大学、清华大学和北京航空航天大学培养）和教练机飞行训练。第4学年结束后，合格学员取得本科学历及工科学士学位，定为副连职军官，授予海军中尉军衔。继续完成高教机训练取得任职培训合格证书的，授予第二学位（军事学学士），职务等级可提前晋升为正连职。期间，因身体或技术等原因不适合继续飞行的，转入其他本科专业学习。", "② 海军飞行学员在校期间费用全免，实行供给制，并享受飞行津贴、空勤伙食、特种装具等待遇。父母享受军属待遇。", "③ 学生报名要自愿，并且应该得到家长的同意与支持。 ", "④ 海军招飞报名考生多、选拔内容多，考生除身体、检测并参加高考外，还需要接受政治考核。 ", "⑤ 海军招飞不收取任何报名和检测费用，复选、定选期间免费安排考生食宿，并按规定报销路费。 ", "⑥ 海军招飞往往在提前批次录取。"],
            //         "recommendReason": "您当前已具备以下报考条件：",
            //         "noRecommendReason": "",
            //         "incompatibleReason": "您不具备以下报考条件：",
            //         "link": "\/wayToStudy\/seaforce",
            //         "conditionOption": ["①", "⑤", "⑥", "⑧"]
            //     }, {
            //         "id": 24,
            //         "title": "民航招飞",
            //         "introduction": "民用航空飞行员是指由指定高校进行培养，这些院校培养的飞行员，毕业后一般定向分配到国航、海航、东航、 中联航及其他国内各航空公司等单位。",
            //         "condition": ["① 年龄：高考时年龄16-20周岁。", "② 身高：男性170-185厘米；女性身高168-180厘米。", "③ 体重：身体质量指数（BMI）不大于24或小于18.5（BMI=体重(kg)\/身高(单位M)2）。", "④ 视力：双眼没有经过任何手术，任何一只眼睛裸视力(按C字视力表)不低于0.1（相当于E字表4.0），无色盲、色弱等眼疾。", "⑤ 无口吃（结巴）。", "⑥ 预计高考分数不低于本省（自治区、直辖市）本科二批、本科B批、本科批次、第二段控制线。", "⑦ 高考时外语考英语。"],
            //         "notice": ["① 报考民航飞行员的学生入学后所学专业为飞行技术专业，全国有19所院校开设了飞行技术专业（本 科）。飞行技术专业属提前录取专业，考生应根据各省各校要求填报志愿。如本人未被飞行专业录取，不 影响考生填报的其它院校、专业的正常录取。", "② 考生通过高考录取后在相关培训院校（一般为中国民航大学或中国民用航空飞行学院）完成四年本科学 习，并完成初始飞行驾驶技术培训。期间，安排部分学员到国外航校进行飞行技术训练。取得相应资格、 证书后进入民航公司。 ", "③ 民航飞行学员毕业后，将被分配到航空公司所属的各分公司当客机驾驶员。职业发展路线可从副驾驶员 到机长，再到飞行教员。"],
            //         "recommendReason": "您当前已具备以下报考条件：",
            //         "noRecommendReason": "",
            //         "incompatibleReason": "您不具备以下报考条件：",
            //         "link": "\/wayToStudy\/civilaviation",
            //         "conditionOption": ["①", "③", "④", "⑤"]
            //     }, {
            //         "id": 25,
            //         "title": "军校招生",
            //         "introduction": "军校生，亦称为军校学员。不论是在解放军军事院校还是武警军事院校中学习的学员，只要是在部队院校中就读 的学生，皆称为军校学员。军校生是指根据军队建设需要，由军队院校从参加国家统一招生考试录取或保送入学 且毕业后由军队统一分配的学生，也是我们常说军校学员。",
            //         "condition": ["① 年龄：考生年龄不低于17周岁、不超过20周岁(截至报考当年8月31日 ) 。", "② 身高：男性身高162cm以上；女性身高160cm以上。", "③ 体重： 男性体重不超过标准体重（标准体重kg=身高cm-110）的30%，不低于标准体重的15%，其中音乐学专业体重不超过标准体重的35%；女性体重不超过标准体重的20%、不低于标准体重的15%，其中，音乐学专业体重不超过标准体重的35%。", "④ 视力：裸眼视力不低于4.5，任何一眼裸眼视力低于4.9，需进行矫正视力检查，任何眼矫正视力低于4.9或矫正度数超过600度，不合格。无色弱、色盲等眼疾。", "⑤ 无口吃（结巴）。", "⑥ 预计高考分数不低于本省（自治区、直辖市）本科二批、本科B批、本科批次、第二段控制线。"],
            //         "notice": ["① 参加全国高考后，还需要通过政治考核、面试和体检。", "② 实行提前批次投档录取。", "③ 军校分为全军院校以及军兵种院校，前者面向全军分配，后者面向本军种分配。", "④ 军校专业分为指挥类专业和非指挥类专业，前者面向军队基层军事、政治、后勤指挥军官及机关工作岗 位，后者面向部队、军队科研单位、军校的技术岗位。", "⑤ 新生入学3个月内，进行政治、身体复查和军事、文化复试，复查合格后取得学籍和军籍。"],
            //         "recommendReason": "您当前已具备以下报考条件：",
            //         "noRecommendReason": "",
            //         "incompatibleReason": "您不具备以下报考条件：",
            //         "link": "\/wayToStudy\/militaryschool",
            //         "conditionOption": ["①", "③", "④", "⑤"]
            //     }, {
            //         "id": 26,
            //         "title": "强基计划",
            //         "introduction": "基础学科招生改革试点，也称强基计划，是教育部开展的招生改革工作，主要是为了选拔培养有志于服务国家重大战略需求且综合素质优秀或基础学科拔尖的学生。\r\n强基计划主要选拔培养有志于服务国家重大战略需求且综合素质优秀或基础学科拔尖的学生。聚焦高端芯片与软件、智能科技、新材料、先进制造和国家安全等关键领域以及国家人才紧缺的人文社会科学领域，由有关高校结合自身办学特色，合理安排招生专业。要突出基础学科的支撑引领作用，重点在数学、物理、化学、生物及历史、哲学、古文字学等相关专业招生。建立学科专业的动态调整机制，根据新形势要求和招生情况，适时调整强基计划招生专业。",
            //         "condition": ["① 预计高考分达到所在省份本科一批录取最低控制分数线（合并录取批次省份以各省份划定分数线为准）。", "② 相关学科领域具有突出才能和表现的考生。该类考生须在全国中学生学科奥林匹克竞赛全国决赛中获得数学、物理、化学、生物、信息学二等奖及以上。"],
            //         "notice": ["①报名考生均须参加全国统一高考。", "②高校考核（含笔试、面试）和体育测试，其中体育测试结果作为录取的重要参考。", "③考生参加统一高考和高校考核后，高校将考生高考成绩、高校综合考核结果及综合素质评价情况等按比例合成考生综合成绩（其中高考成绩所占比例不得低于85%）根据考生填报志愿，按综合成绩由高到低顺序录取。", "④对于符合高校破格入围条件的考生，考生高考成绩应达到高校招生简章确定的要求，且原则上不得低于各省（区、市）本科一批录取最低控制分数线。"],
            //         "recommendReason": "您当前已具备以下报考条件：",
            //         "noRecommendReason": "",
            //         "incompatibleReason": "您不具备以下报考条件：",
            //         "link": "",
            //         "conditionOption": ["①"]
            //     }]
            // },
        }
    },
    methods: {
        goSubmit() {
            if(this.navIndex==2) {
                this.storePlan();
            }else {
              document.scrollingElement.scrollTop = 0;
                this.navIndex++;

            }

        },
        storePlan(){
            let studentId = this.studentId;
            let interviewRecord = this.interviewRecord;
            let goalPlanObj = this.goalPlanObj;
            let furtherWayObj = this.furtherWayObj;
            let chooseSubjectObj = this.chooseSubjectObj;
            let careerMajorObj = this.careerMajorObj;
            let plan ={
                universityScore: goalPlanObj.universityScore,
                universityIdName:goalPlanObj.universityIdName,
                score: goalPlanObj.score,
                rank: goalPlanObj.rank,
                remarkLog: goalPlanObj.remarkLog,//咨詢記錄

                furtherWay: furtherWayObj.furtherWay,//升学路径
                furtherWayNeed:furtherWayObj.furtherWayNeed,//路径条件
                furtherWayNeedOther:furtherWayObj.furtherWayNeedOther,//其他条件
                furtherWayRemark: furtherWayObj.furtherWayRemark,//咨询总结

                // chooseSubjectName: chooseSubjectObj.chooseSubjectName,//選科方案
                chooseSubjectRequire: chooseSubjectObj.chooseSubjectRequire,//目标院校对目标专业的选科要求
                chooseSubjectRemark: chooseSubjectObj.chooseSubjectRemark,//选科调整记录

                targetCareerField: careerMajorObj.targetCareerField,
                targetCareer: careerMajorObj.targetCareer,
                targetSubject: careerMajorObj.targetSubject,
                targetRemark: careerMajorObj.targetRemark,
                professional:this.version==1?'':this.professional,
                chooseSubjectName: chooseSubjectObj.chooseSubjectName.length > 0 ? chooseSubjectObj.chooseSubjectName : chooseSubjectObj.hadCheckedList,//選科方案
            }
            
            this.$ajax.post(this.G_acapi + this.ports.consultant.student.mine.planningContent.storePlan, {
                studentId: studentId,
                interviewRecord:interviewRecord,
                plan: plan,
                
            }, {
                headers: {
                    token: window.sessionStorage.getItem('ymtxToken')
                }
            }).then((res) => {
                let data = res.data;
                if (data.code == 2000) {
                    this.$router.replace('/consultant/minestudent/main/planningContent/recordList')
                }else{
                    this.$message.error(res.data.msg)
                }
            })
        },
        getStudentPartBDetail(){
            let studentId = this.studentId;
            this.$ajax.post(this.G_acapi + this.ports.consultant.student.mine.planningContent.getStudentPartBDetail, {
                studentId: studentId,
            }, {
                headers: {
                    token: window.sessionStorage.getItem('ymtxToken')
                }
            }).then((res) => {
                let data = res.data;
                if (data.code == 2000) {
                    this.careerMajorObj = {
                        targetCareerField : data.data.targetCareerField,
                        targetCareer : data.data.targetCareer,
                        targetSubject : data.data.targetSubject,
                        
                    }
                    this.professional = data.data.professional
                    this.version = data.data.version
                }else{

                }
            })
        },
        getStudentCensusQuestion(){
            let studentId = this.studentId;
            this.$ajax.post(this.G_acapi + this.ports.consultant.student.mine.planningContent.getStudentCensusQuestion, {
                studentId: studentId,
            }, {
                headers: {
                    token: window.sessionStorage.getItem('ymtxToken')
                }
            }).then((res) => {
                let data = res.data;
                if (data.code == 2000) {
                    this.awarded = data.data.censusQuestion.awarded;
                    this.otherWayList = data.data.censusQuestion.otherWayList;
                }else{

                }
            })
        },
        // 获取升学途径报告
        getLastFurtherWayByStudentId(){
            let studentId = this.studentId;
            this.$ajax.post(this.G_acapi + this.ports.consultant.student.mine.planningContent.getLastFurtherWayByStudentId, {
                studentId: studentId,
            }, {
                headers: {
                    token: window.sessionStorage.getItem('ymtxToken')
                }
            }).then((res) => {

                if (res.data.code == 2000) {
                    let data = res.data.data.data;
                    if(!Array.isArray(data)) {
                        this.reportData = data;
                    }
                }
            })
        },
    },
    created() {
        this.getStudentPartBDetail();
        this.getStudentCensusQuestion();
        this.getLastFurtherWayByStudentId();
    }
}
</script>

<style scoped lang="less">
.addFirstPlaning {
    .content {
        padding: 25px 30px;
        padding-bottom: 0px;
        background-color: #fff;
    }
    .bigTitle {
        font-size: 20px;
        font-weight: bold;
        margin-bottom: 15px;
    }
    .targetSchool {
        margin-bottom: 20px;
        .targetSchoolBox {
            line-height: 30px;
            span {
                font-size: 16px;
                margin-right: 40px;
            }
        }
    }
    .achieve {
        padding-bottom: 20px;
        ul {
            padding: 20px 35px;
            background-color: #F0F9FE;

            li {
                line-height: 35px;
                display: flex;
                flex-wrap: wrap;
                justify-content: space-between;
                p {
                    width: 30%;
                }
            }
        }
    }
    .topTitle {
        line-height: 30px;
        font-size: 22px;
        font-weight: bold;
        padding-bottom: 40px;
        .active {
            color: #3d90f6;
        }
    }
    .mine-planningContent-careerTuijian {
        overflow: hidden;
        .tuijianTitle {
            font-size: 20px;
            font-weight: bold;
            margin-bottom: 30px;
        }
        .tuijian {
            background: rgba(61, 144, 246, 0.2);
            border-radius: 4px;
            padding: 20px 40px;
            margin-bottom: 20px;
            p {
                line-height: 30px;
            }
        }
        .flexBox {
            display: flex;
            margin-bottom: 20px;
            font-size: 16px;
            line-height: 30px;
            div {
                padding-left: 10px;
                display: flex;
                flex-wrap: wrap;
                flex: 1;
            }
            span {
                cursor: pointer;
                margin-right: 10px;
            }
        }
    }
}
</style>